"use strict";

exports.__esModule = true;
exports["default"] = abTranslate;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function abTranslate(experiments, translations) {
  if (!experiments || experiments.toString() !== '[object Object]') {
    return translations;
  }
  if (!translations) {
    return {};
  }
  //create a hash that contains the conversion between the old key and the new key
  var abExperiments = {};
  var _loop = function _loop() {
    if (Object.prototype.hasOwnProperty.call(experiments, expKey)) {
      var experimentValue = experiments[expKey];
      var isAbTest = /specs\.abTranslate\.(.*?)\.(.*)$/.exec(expKey);
      if (isAbTest) {
        var translationDetails = isAbTest[2];
        var _translationDetails$s = translationDetails.split('abSpec-'),
          _translationKey = _translationDetails$s[0],
          specName = _translationDetails$s[1];
        var translationKeys;
        if (specName) {
          // We use Array.from because Yoshi uses Babel in loose mode
          // which unsafely transpiles Array spread on non-arrays (like a Set)
          translationKeys = Array.from(new Set(Object.keys(translations).filter(function (key) {
            return key.includes(specName);
          }).map(function (key) {
            return key.split('|abTranslate')[0];
          })));
        } else {
          translationKeys = [_translationKey];
        }
        translationKeys.forEach(function (key) {
          abExperiments[key] = key;
          if (experimentValue !== '0') {
            var specSuffix = specName ? "|" + specName : "";
            abExperiments[key] = key + "|abTranslate_" + experimentValue + specSuffix;
          }
        });
      }
    }
  };
  for (var expKey in experiments) {
    _loop();
  }
  var updatedTranslations = _objectSpread({}, translations);
  //replace existing translation keys with abTest results
  for (var translationKey in abExperiments) {
    // eslint-disable-line guard-for-in
    var translationHasExperiment = Object.prototype.hasOwnProperty.call(abExperiments, translationKey);
    var doesAbTranslationKeyExist = translations[abExperiments[translationKey]];
    if (translationHasExperiment && doesAbTranslationKeyExist) {
      updatedTranslations[translationKey] = translations[abExperiments[translationKey]];
    }
  }
  return updatedTranslations;
}